<template>
  <nav v-if="visibilità" class="container_j">
    <div
      v-for="filtro in elenco_filtri"
      v-if="filtro.tipo_filtro === 'scheda'"
      class="btn-group"
      role="group"
    >
      <div class="radio-toolbar" v-for="val in filtro.valori">
        <input
          type="radio"
          @change="conferma_filtro()"
          :id="val.valore"
          :value="val.valore"
          v-model="filtro.valore_attuale"
        >
        <label :for="val.valore">{{val.nome_opzione}}</label>
      </div>
    </div>
    <select
      class="selector"
      @change="conferma_filtro()"
      v-for="filtro in elenco_filtri"
      v-if="filtro.tipo_filtro === 'select'"
      v-model="filtro.valore_attuale"
    >
      <option class="selector" style="color:white !important;" disabled>{{filtro.nome_filtro}}</option>
      <option style="color:white !important;" v-for="val in filtro.valori">{{val.nome_opzione}}</option>
    </select>
    <input hidden style="margin-left:20px;" type="checkbox" id="switch" v-model="filtro_live">
    <label hidden style="margin-left:20px;" for="switch">{{filtro_live}}</label>
    <div class="totale_merce">
      <span style="display:none ;font-size:12px;">Totale Utile:</span>&nbsp
      <b>
        <span style="display:none ;font-size:12px;" id="valore_merce" name="valore_merce">0,00€</span>
      </b>
    </div>
  </nav>
</template>

<script scoped>
/* TODO
	-RIPULIRE IL CODICE DAI COMMENTI UNA VOLTA CHE TUTTO è OK
*/
import filtri_ordini from "../config/filtri/filtri_ordini.json";
import filtri_clienti from "../config/filtri/filtri_clienti.json";
import filtri_magazzino from "../config/filtri/filtri_magazzino.json";

export default {
  name: "Filtri",
  data() {
    return {
      filtro_live: true,
      primo_caricamento: true,
      elenco_filtri: "",
      visibilità: true
      //fare una funzione che regola la visibilita dei filtri o
      //mettere anche animazione
    };
  },
  updated() {
    if (!this.primo_caricamento) {
      this.conferma_filtro();
    } else {
      this.setta_filtri();
    }

    this.primo_caricamento = false;
  },
  methods: {
    // qui costruisco il link a partire dai filtri
    setta_filtri() {
      for (let i = 0, len = this.elenco_filtri.length; i < len; i++) {
        let nome_filtro = this.elenco_filtri[i].nome_filtro;
        if (this.$route.query[nome_filtro]) {
          this.elenco_filtri[i].valore_attuale = this.$route.query[nome_filtro];
        }
      }
    },
    conferma_filtro() {
      var valido = false;
      if (this.filtro_live) {
        var stringa_filtro = "?";
        for (var i = 0, len = this.elenco_filtri.length; i < len; i++) {
          if (
            this.elenco_filtri[i].valore_attuale !==
            this.elenco_filtri[i].nome_filtro
          ) {
            valido = true;
            if (i === 0) {
              stringa_filtro += "?";
            }
            stringa_filtro += this.elenco_filtri[i].nome_filtro;
            stringa_filtro += "=";
            stringa_filtro += this.elenco_filtri[i].valore_attuale;
            // sistemare il fatto  che alla fine delle stringa da appenadere all url c'è sempre '&''
            if (this.elenco_filtri.length - i > 1) {
              stringa_filtro += "&";
            }
          }
        }
        //console.log('confermato filtro' + stringa_filtro)
        // appendere stringa all url solamente se i parametri sono validi
        if (valido) {
          this.$router.push(this.$route.path + stringa_filtro);
        }
      }
    }
  },
  watch: {
    $route() {
      //REGOLE DI VISIBILITà FILTRI
      this.elenco_filtri = filtri_clienti;

      if (this.$route.path === "/ordini") {
        // case sensitive occhio !!
        this.elenco_filtri = filtri_ordini;
      }
      if (this.$route.path === "/listini") {
        // case sensitive occhio !!
        this.elenco_filtri = filtri_clienti;
      }
      if (this.$route.path === "/magazzino") {
        // case sensitive occhio !!
        this.elenco_filtri = filtri_clienti;
      }

      //serve davvero??
      //this.setta_filtri()
    },
    // quando riattivo il filtro live esegue la ricerca
    filtro_live() {
      if (this.filtro_live) {
        this.conferma_filtro();
      }
    }
  }
};
</script>

<style scoped>
/*   FILTRI   */
.container_j{
  
}
.selector {
  color: white !important;
  background-color: rgb(4, 132, 196) !important;
}

.selector option {
  color: white !important;
}

.container_j .radio-toolbar input[type="radio"] {
  display: none;
}
.container_j .radio-toolbar label {
  display: inline-block;
  font-size:1.7vh;
  color: white;
  cursor: pointer;
  margin-right: 20px;
  padding: 5px;
  margin-bottom: 0px;
  border-radius: 0px !important;
  outline: 0 !important;
}

.container_j .radio-toolbar input[type="radio"]:checked + label {
  font-weight: bold;
  border-bottom: solid 4px white ;
  border-radius: 0px !important;
  outline: 0 !important;
}

.container_j .divisore {
  border-right-style: solid;
  border-right-color: #dedede;
  border-right-width: 1px;
  width: 1px;
  height: 25px;
  margin-left: 10px;
  margin-right: 10px;
}

.container_j select {
  margin-left: 10px;
  border: 0;
  background-color: #f9f9f9;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  font-size: 13px;
  height: 25px;
  width: 130px;
  color: #626262;
}

.container_j select:focus {
  outline: none;
}

.totale_merce {

  position: absolute;
  right: 30px;
  font-size: 14px;
  color: white;
}
</style>
